import type React from "react";

export interface DownloadedFile {
  filename: string;
  path: string;
  timestamp: string;
  size?: number;
  status: "completed" | "failed" | "error";
  error?: string;
}

interface LogModalProps {
  isOpen: boolean;
  onClose: () => void;
  logs: string[];
  downloadedFiles?: DownloadedFile[];
}

const LogModal: React.FC<LogModalProps> = ({
  isOpen,
  onClose,
  logs,
  downloadedFiles = [],
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "5px",
          width: "80%",
          maxWidth: "600px",
        }}
      >
        <h2>Execution Logs</h2>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          {logs.join("\n")}
        </pre>

        <h2>Downloaded Files</h2>
        {downloadedFiles.length === 0 ? (
          <p>No files downloaded</p>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr>
                <th style={tableHeaderStyle}>Filename</th>
                <th style={tableHeaderStyle}>Status</th>
                <th style={tableHeaderStyle}>Size</th>
                <th style={tableHeaderStyle}>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {downloadedFiles.map((file, index) => (
                <tr key={index} style={tableRowStyle}>
                  <td style={tableCellStyle}>{file.filename}</td>
                  <td style={tableCellStyle}>
                    <span style={getStatusStyle(file.status)}>
                      {file.status}
                    </span>
                  </td>
                  <td style={tableCellStyle}>
                    {file.size ? `${(file.size / 1024).toFixed(2)} KB` : "N/A"}
                  </td>
                  <td style={tableCellStyle}>
                    {new Date(file.timestamp).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <button
          onClick={onClose}
          style={{
            padding: "10px 20px",
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "12px",
  textAlign: "left" as const,
  borderBottom: "2px solid #ddd",
  backgroundColor: "#f5f5f5",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};

const tableCellStyle = {
  padding: "12px",
};

const getStatusStyle = (status: string) => ({
  color:
    status === "completed" ? "green" : status === "failed" ? "red" : "orange",
});

export default LogModal;
